/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { atom } from 'jotai';
import { ChatServices } from 'src/libs/services/chat.service';
import { converHistoryMessage } from 'src/libs/utils/convert-data-history-messages';
import { ChatMessageProps } from '../components/chat-message/ChatMessage';

export const historyAtom = atom<any[]>([]);

export const getHistoryAtom = atom(
  null,
  async (get, set) => {
    const response = await ChatServices.getConversations();
    const data = response.data;
    set(historyAtom, data);
  }
);

export const conversationId = atom<string | null>(null);
export const listMessageHistory = atom <ChatMessageProps[]>([]);

